import step1_1 from "@/assets/integration-steps/microsoft/step_1_1.png";
import step1_2 from "@/assets/integration-steps/microsoft/step_1_2.png";
import step1_3 from "@/assets/integration-steps/microsoft/step_1_3.png";
import step1_4 from "@/assets/integration-steps/microsoft/step_1_4.png";
import step1_5 from "@/assets/integration-steps/microsoft/step_1_5.png";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
interface Props {
  stepLabel?: string;
}

const MicrosoftIntegrationStep1 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step microsoft-step-1">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>UET tag installation</h6>
    </div>
    <div className="wrapper">
      <p>
        The UET Tag is the piece of code that allows Microsoft Ads to track
        conversions or add users to Audiences.
      </p>
      <p>
        Opticks uses these Audiences to exclude invalid traffic, so the first
        step is to make sure that both Opticks and your UET tag are properly
        installed in the page you want to protect. Start by creating the UET tag
        and adding it to your page.
      </p>
    </div>
    <img src={step1_1} alt="Screenshot of step 1.1 Microsoft Integration" />
    <img src={step1_2} alt="Screenshot of step 1.2 Microsoft Integration" />
    <img src={step1_3} alt="Screenshot of step 1.3 Microsoft Integration" />
    <img src={step1_4} alt="Screenshot of step 1.4 Microsoft Integration" />
    <img src={step1_5} alt="Screenshot of step 1.5 Microsoft Integration" />
  </div>
);

export default MicrosoftIntegrationStep1;
